export const pluralize = (word, count = 2) => count > 1 ? `${word}s` : word;